export enum Path {
  CharitiesWithAnApp = '/solutions/charitiesWithAnApp',
  FAQsBrands = '#brands',
  FAQsPartners = '#partners',
  FAQsUsers = '#users',
  FAQsCharities = '#charities',
  Home = '/',
  MobileApp = '/solutions/mobileApp',
  MobileGame = '/solutions/mobileGame',
  MobileNetwork = '/solutions/mobileNetwork',
  Keyboard = '/solutions/keyboard',
  Cashback = '/solutions/cashback',
  UnderTheHood = '/FAQ',
  Loyalty = '/loyalty',
  Revenue = '/revenue',
  ESG = '/esg',
  RequestADemo = '#requestADemo',
  RequestADemoHomepage = '/#requestADemo',
  Network = '/network',
  AboutUs = '/aboutUs',
  Gaming = '/gaming',
  ProductDesktop = '/product/desktop',
  ProductApi = '/product/api',
  GetAPIKey = '#',
  KeyboardInstallationGuide = '/keyboard-activation',
  PluginActivation = '/plugin-activation',
  O2PluginActivation = '/o2/plugin-activation',
  AndroidKeyboardInstallationGuide = '/android/keyboard-activation/:step',
  ProductHome = '/product/home',
  ProductExtension = '/product/extension',
  SamsungLanding = '/samsung',
  SamsungActivation = '/samsung/activation',
  ExtensionInstalled = '/extension-installed',
  ExtensionUninstalled = '/extension-uninstalled',
  ExtensionInstalledV2 = '/v2/extension-installed',
  ExtensionUninstalledV2 = '/v2/extension-uninstalled',
  DesktopLanding = '/v2/desktop',
  TreePlanting = '/tree-planting/:partner?',
  PluginActivationV2 = '/v2/plugin-activation',
  EtisalatOfferWall = '/etisalat/wall',
  EtisalatOfferWallArabic = '/etisalat/wall/arabic',
  TIMActivationHome = '/tim/activation',
  TIMHomePage = '/tim',
  TIMAndroidActivationHome = '/tim/activation-android',
  PluginActivationReviewPermissionsV2 = '/v2/plugin-activation/review-permissions',
  ChromeExtensionDownload = '/chrome/extension-download',
  PluginActivationReviewPermissions = '/plugin-activation/review-permissions',
  PluginActivationUpdatePermissions = '/plugin-activation/update-permissions',
  PluginActivationAllowPermissions = '/plugin-activation/allow-permissions',
  PluginActivationStartShopping = '/plugin-activation/start-shopping',
  PluginActivationV2ActivatePlugin = '/v2/plugin-activation/activate-plugin',
  TimPluginActivationActivatePlugin = '/tim/activation-ios',
  TimPluginActivationAlwaysAllow = '/tim/activation-ios/permissions',
  TimPluginActivationPartialPermissions = '/tim/activation-ios/partial',
  TimPluginActivationStartShopping = '/tim/activation-ios/success',
  TimPluginActivationAndroidStartShopping = '/tim/activation-android/success',
  EonPluginActivationHome = '/eon/activation',
  EonPluginActivationMultiStep = '/eon/activation-ios',
  EonPluginActivationAlwaysAllow = '/eon/activation-ios/permissions',
  EonPluginActivationPartialPermissions = '/eon/activation-ios/partial',
  EonPluginActivationStartShopping = '/eon/activation/success',
  EonPluginAndroidAccessibility = '/eon/activation-android',
  NTVPluginActivationHome = '/ntv/activation',
  NTVPluginActivationMultiStep = '/ntv/activation-ios',
  NTVPluginActivationAlwaysAllow = '/ntv/activation-ios/permissions',
  NTVPluginActivationPartialPermissions = '/ntv/activation-ios/partial',
  NTVPluginActivationStartShopping = '/ntv/activation/success',
  NTVPluginAndroidAccessibility = '/ntv/activation-android',
  NTVPluginActivationAlternateBrowser = '/ntv/activation-alternate-browser',
  BlueLightCardPluginActivationHome = '/bluelightcard/activation',
  BlueLightCardPluginActivationMultiStep = '/bluelightcard/activation-ios',
  BlueLightCardPluginActivationAlwaysAllow = '/bluelightcard/activation-ios/permissions',
  BlueLightCardPluginActivationPartialPermissions = '/bluelightcard/activation-ios/partial',
  BlueLightCardPluginActivationStartShopping = '/bluelightcard/activation/success',
  BlueLightCardPluginAndroidAccessibility = '/bluelightcard/activation-android',
  PluginActivationV2AlwaysAllow = '/v2/plugin-activation/always-allow',
  PluginActivationV2PartialPermissions = '/v2/plugin-activation/partial-permissions',
  PluginActivationV2StartShopping = '/v2/plugin-activation/start-shopping',
  NationalRailExtensionInstalled = '/nationalrail/extension-installed',
  NationalRailLanding = '/nationalrail',
}
